import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ImageLoadContextType {
  imagesLoaded: boolean;
  setImagesLoaded: React.Dispatch<React.SetStateAction<boolean>>;
}

const ImageLoadContext = createContext<ImageLoadContextType | undefined>(
  undefined
);

export const useImageLoad = (): ImageLoadContextType => {
  const context = useContext(ImageLoadContext);
  if (!context) {
    throw new Error('useImageLoad must be used within an ImageLoadProvider');
  }
  return context;
};

interface ImageLoadProviderProps {
  children: ReactNode;
}

export const ImageLoadProvider: React.FC<ImageLoadProviderProps> = ({
  children,
}) => {
  const [imagesLoaded, setImagesLoaded] = useState<boolean>(false);

  return (
    <ImageLoadContext.Provider value={{ imagesLoaded, setImagesLoaded }}>
      {children}
    </ImageLoadContext.Provider>
  );
};
